import { injectable } from 'inversify';
import { v4 as uuidv4 } from 'uuid';
import { Book, BookSection } from '@Models';
import { Result } from '@Redux/type';
import { BookSectionCreateParams } from '@Components/publication/book-section-new/validate';
import { ILoadingEntityAction } from '@Redux/ILoadingEntityAction';
import { PayloadAction } from '@reduxjs/toolkit';
import bookSlice from '@Redux/reducers/publication/book.slice';
import myBookSlice from '@Redux/reducers/publication/book.slice';
import bookSectionSlice from '@Redux/reducers/publication/book-section.slice';

@injectable()
export class BookSectionAction extends ILoadingEntityAction {
  public fetchDataSuccess = (book: Book): PayloadAction<Book> =>
    myBookSlice.actions.setMyBook(book);

  public actionRequestClone = (
    section: BookSection,
  ): PayloadAction<BookSection> =>
    bookSectionSlice.actions.setRequestClone(section);

  public actionRequestEdit = (
    section: BookSection,
  ): PayloadAction<BookSection> =>
    bookSectionSlice.actions.setRequestEdit(section);

  public actionRequestDelete = (
    section: BookSection,
  ): PayloadAction<BookSection> =>
    bookSectionSlice.actions.setRequestDelete(section);

  public cancel = (): PayloadAction => bookSectionSlice.actions.setCancel();

  public create =
    (values: BookSectionCreateParams): Result<void> =>
    async (dispatch, getState) => {
      dispatch(this.areLoading(true));

      const book = getState().book.entity!!;

      const section = {
        id: uuidv4(),
        position: book.sections.length + 1,
        isDeleted: false,
      } satisfies BookSection as BookSection;
      book.sections.push(section);
      book.updatedAt = new Date().getTime();

      dispatch(this.fetchDataSuccess(book));
    };

  public clone =
    (section: BookSection): Result<void> =>
    async (dispatch, getState) => {
      dispatch(this.areLoading(true));

      const book = getState().book.entity!!;

      const newSection = {
        ...section,
        id: uuidv4(),
        position: book.sections.length + 1,
      };
      newSection.id = uuidv4();
      newSection.position = book.sections.length + 1;

      book.sections.push(newSection);
      book.updatedAt = new Date().getTime();

      dispatch(this.fetchDataSuccess(book));
      dispatch(this.areLoading(false));
    };

  public delete =
    (id: string): Result<void> =>
    async (dispatch, getState) => {
      dispatch(this.areLoading(true));

      const book = getState().book.entity!!;

      book.sections = book.sections.map((s: any) => {
        if (s.id === id) {
          s.isDeleted = true;
        }

        return s;
      });
      book.updatedAt = new Date().getTime();

      dispatch(this.fetchDataSuccess(book));
      dispatch(this.areLoading(false));
    };

  protected haveError(message: string): PayloadAction<string> {
    return bookSlice.actions.setError(message);
  }

  protected areLoading(bool: boolean): PayloadAction<boolean> {
    return bookSlice.actions.setLoading(bool);
  }
}
